import { PressReleaseFlat } from "@clients/afaseApiClient";

import { UrlStructureItem } from "types/UrlStructureItem";

export const PressreleaseUrlStructureFactory = (
  array: Array<PressReleaseFlat>,
): UrlStructureItem[] => {
  return array
    .filter((item) => item && item.slug && item.heading)
    .map((item) => ({
      name: item.heading,
      slug: item.slug,
      url: `/om-oss/pressrum/${item.slug}`,
    }));
};
